import React, { Component } from 'react';
import JobOfferLayoutContent from '../../layout/jobOffer/JobOfferLayoutContent';
import Helmet from 'react-helmet';
import { JobOffer, JobOfferQuestionnaire } from '../../../api/jobOffers/jobOffers.state';
import { ErrorState } from '../../../api/_commons/state.common';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { ThunkDispatch } from '../../../api/_commons/thunks.common';
import { State } from '../../../store/state';
import { JobOffersThunks } from '../../../api/jobOffers/jobOffers.thunk';
import { Preloader } from '@epicode/react-inspinia';
import NotFound from '../../page/NotFound';
import InternalError from '../../page/InternalError';
import OfferApplicationForm from './OfferApplicationForm';
import JobOfferLayoutHeader from '../../layout/jobOffer/JobOfferLayoutHeader';

interface OfferApplicationContainerStateProps {
    offer?: JobOffer;
    isLoading: boolean;
    error: ErrorState;
}

interface OfferApplicationContainerDispatchProps {
    fetchOffer: () => void;
}

interface OfferApplicationRouteProps {
    id: string;
}

interface OfferApplicationProps {
    applyLink?: string;
    jobTitle: string;
    questionnaireStructure: JobOfferQuestionnaire;
    locationDescription: string;
    locationLatitude: number;
    locationLongitude: number;
    createDate: string;
    deadline: string;
}

const OfferApplication = (props: OfferApplicationProps) => {
    return (
        <>
            <Helmet>
                <title>ATS - {props.jobTitle}</title>
            </Helmet>

            <JobOfferLayoutHeader
                applyLink={props.applyLink}
                jobTitle={props.jobTitle}
                locationDescription={props.locationDescription}
                locationLatitude={props.locationLatitude}
                locationLongitude={props.locationLongitude}
                createDate={props.createDate}
                deadline={props.deadline}
            />

            <JobOfferLayoutContent>
                <OfferApplicationForm questionnaireStructure={props.questionnaireStructure} />
            </JobOfferLayoutContent>
        </>
    );
};

class OfferApplicationContainer extends Component<
    OfferApplicationContainerStateProps &
        OfferApplicationContainerDispatchProps &
        RouteComponentProps<OfferApplicationRouteProps>
> {
    componentDidMount() {
        // if the offer is not loaded already - load it now
        if (!this.props.offer) {
            this.props.fetchOffer();
        }
    }

    render() {
        const { isLoading, error, offer } = this.props;

        if (error) {
            if (error.httpStatus === 404) {
                return <NotFound />;
            }

            return <InternalError />;
        }

        if (!isLoading && !offer) {
            return <NotFound />;
        }

        return (
            <>
                {isLoading && <Preloader overlay />}
                {offer && <OfferApplication {...offer} />}
            </>
        );
    }
}

const mapStateToProps = (
    state: State,
    props: RouteComponentProps<OfferApplicationRouteProps>
): OfferApplicationContainerStateProps => ({
    isLoading: state.jobOffers.isLoading,
    error: state.jobOffers.error,
    offer: state.jobOffers.items[props.match.params.id]
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch,
    props: RouteComponentProps<OfferApplicationRouteProps>
): OfferApplicationContainerDispatchProps => ({
    fetchOffer: () => dispatch(JobOffersThunks.getJobOffer(props.match.params.id))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OfferApplicationContainer));
